/* Supply video testimonial slider: centers the active 9:16 card, dims neighbours, per-card play/mute. */
(function () {
  if (customElements.get('supply-video-slider')) return;

  class SupplyVideoSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.indicators = Array.from(this.querySelectorAll('[data-goto]'));
      this.index = Math.min(parseInt(this.dataset.start || '0', 10), this.slides.length - 1);
      if (this.index < 0) this.index = 0;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.indicators.forEach((b) => b.addEventListener('click', () => this.go(parseInt(b.dataset.goto, 10))));

      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        const play = slide.querySelector('[data-play]');
        const mute = slide.querySelector('[data-mute]');
        slide.addEventListener('click', (e) => {
          if (i !== this.index) {
            e.preventDefault();
            this.go(i);
          }
        });
        play?.addEventListener('click', (e) => {
          e.stopPropagation();
          if (i !== this.index) return this.go(i);
          this.toggle(video, slide);
        });
        mute?.addEventListener('click', (e) => {
          e.stopPropagation();
          if (!video) return;
          video.muted = !video.muted;
          mute.setAttribute('aria-pressed', String(video.muted));
          mute.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
          slide.classList.toggle('is-unmuted', !video.muted);
        });
        video?.addEventListener('ended', () => slide.classList.remove('is-playing'));
      });

      // swipe support
      let startX = 0;
      this.track.addEventListener('touchstart', (e) => (startX = e.touches[0].clientX), { passive: true });
      this.track.addEventListener(
        'touchend',
        (e) => {
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
        },
        { passive: true }
      );

      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this);
      this.layout();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    toggle(video, slide) {
      if (!video) return;
      if (video.paused) {
        this.slides.forEach((s) => {
          if (s !== slide) {
            s.querySelector('video')?.pause();
            s.classList.remove('is-playing');
          }
        });
        video.play().then(() => slide.classList.add('is-playing')).catch(() => {});
      } else {
        video.pause();
        slide.classList.remove('is-playing');
      }
    }

    go(i) {
      const n = this.slides.length;
      if (!n) return;
      const next = ((i % n) + n) % n;
      if (next !== this.index) {
        const current = this.slides[this.index];
        current?.querySelector('video')?.pause();
        current?.classList.remove('is-playing');
      }
      this.index = next;
      this.layout();
    }

    layout() {
      const n = this.slides.length;
      if (!n) return;
      const containerWidth = this.track.parentElement.clientWidth;
      const slide = this.slides[0];
      const slideWidth = slide.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const offset = containerWidth / 2 - slideWidth / 2 - this.index * (slideWidth + gap);
      this.track.style.transform = `translateX(${offset}px)`;
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
      this.indicators.forEach((b, i) => {
        b.classList.toggle('is-active', i === this.index);
        b.setAttribute('aria-selected', String(i === this.index));
      });
    }
  }

  customElements.define('supply-video-slider', SupplyVideoSlider);
})();
